import React from 'react';
import './Footer.css'; // Opcional para estilos específicos

const Footer = () => {
  return (
    <footer className='footer' style={{}}>
      <p className='footer-text'>power by <a href='https://www.tresatec.com.ar' target='_blank' rel='noreferrer'><img className='footer-logo' src='https://www.tresatec.com.ar/img/tresatec-logo-mix.png' onError={(e) => { e.target.style.display = 'none'; }} alt="Tresatec" /></a> © 2026  </p>
    </footer>
  );
};

export default Footer;
